<template>
  <div class="risk-container">
    <div class="risk-header">
      <el-button type="primary" @click="add" style="margin-bottom:15px;">添加</el-button>
      <el-tooltip class="item" effect="dark" placement="top" style="margin-left: 10px; display: inline-block; float: right;">
        <div slot="content">
          <p>#单项Q值=（折纯量&最大存储量）/临界量  （有折纯用折纯，没有用最大存储量）</p>
          <p>#总Q值=sum（各单项Q值）</p>
          <p>#Q值计算保留2个小数位，四舍五入取整</p>
          <p>#国标中风险物质分类无法详尽描述，可选择多个主分类后，在【风险物质细分补充说明】进行说明，每一行仅一个子分类说明：如</p>
          <p>##国标第三部分 有毒液态物质 乙苯，可以选择3列，分别说明为</p>
          <p>【乙苯】、【油漆、稀释剂中的乙苯】、【胶黏剂(按乙苯极)】</p>
        </div>
        <span style="color: #409EFF; cursor: pointer;">填写说明</span>
      </el-tooltip>
    </div>
    <div class="risk-content">
      <!-- 分组表格 -->
      <div v-if="hasSubstanceType" class="grouped-table-container">
        <el-card v-for="(group, index) in groupedData" :key="index" class="group-card">
          <template v-if="group.type" slot="header">
            <div class="card-header">
              <span>{{ formatSubstanceType(group.type) }}</span>
              <span class="q-value">Q值合计: {{ group.total.toFixed(2) }}</span>
            </div>
          </template>
          <el-table
            :data="group.items"
            border>
            <el-table-column type="index">
            </el-table-column>
            <el-table-column prop="riskType" label="风险物质类型">
              <template slot-scope="scope">
                {{ formatRiskType(scope.row.riskType) }}
              </template>
            </el-table-column>
            <el-table-column prop="cas" label="CAS号">
            </el-table-column>
            <el-table-column prop="name" label="物质名称">
              <template slot-scope="scope">
                <div class="riskName">
                  <span>{{ scope.row.name }}</span>
                  <i class="el-icon-edit" @click="modify(scope.row)"></i>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="criticalValue" label="临界量(吨)">
            </el-table-column>
            <el-table-column prop="state" label="形态">
              <template slot-scope="scope">
                {{ formatState(scope.row.state) }}
              </template>
            </el-table-column>
            <el-table-column prop="count" label="最大存储量(吨)">
            </el-table-column>
            <el-table-column prop="purity" label="折纯量(吨)">
            </el-table-column>
            <el-table-column prop="remark" label="补充说明">
            </el-table-column>
            <el-table-column prop="qValue" label="Q值">
            </el-table-column>
            <el-table-column label="操作" fixed="right">
              <template slot-scope="scope">
                <el-button size="mini" type="danger" icon="delete" @click="delectRisk(scope.row)"></el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </div>

      <!-- 非分组表格 -->
      <div v-else class="normal-table-container">
        <el-table
          :data="tableData"
          border>
          <el-table-column type="index">
          </el-table-column>
          <el-table-column prop="name" label="物质名称">
            <template slot-scope="scope">
              <div class="riskName">
                <span>{{ scope.row.name }}</span>
                <i class="el-icon-edit" @click="modify(scope.row)"></i>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注">
          </el-table-column>
          <el-table-column prop="cas" label="CAS号">
          </el-table-column>
          <el-table-column prop="state" label="形态">
            <template slot-scope="scope">
              {{ formatState(scope.row.state) }}
            </template>
          </el-table-column>
          <el-table-column prop="count" label="数量(吨)">
          </el-table-column>
          <el-table-column prop="purity" label="折纯量(吨)">
          </el-table-column>
          <el-table-column prop="criticalValue" label="临界量(吨)">
          </el-table-column>
          <el-table-column prop="qValue" label="Q值">
          </el-table-column>
          <el-table-column label="操作" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" type="danger" icon="delete" @click="delectRisk(scope.row)"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 添加风险物资 -->
    <el-dialog title="添加风险物质" v-model="dialogVisible" size="small" id="dialogVisible">
      <div style="overflow: hidden;">
        <div class="risk-left">
          <div class="top">
            <el-input placeholder="搜索" icon="search" @keyup.enter.native="get_material_list" size="small"
                      v-model="searchrisk" :on-icon-click="handleIconClick">
            </el-input>
          </div>
          <div class="list">
            <ul>
              <li v-for="(item,index) in materialData" :key="index" :class="{activeSel:matSelIndex===index}"
                  @click="handleSel(item,index)">
                {{ item.name }}
              </li>
            </ul>
          </div>
        </div>
        <div class="risk-right">
          <div class="it">
            <span class="tlt">物质：</span>
            <span class="value" :title="paramsModel.name">{{ paramsModel.name }}</span>
          </div>
          <div class="it">
            <span class="tlt">CAS号：</span>
            <span class="value">{{ paramsModel.cas }}</span>
          </div>
          <div class="it">
            <span class="tlt">临界量(吨)：</span>
            <span class="value">{{ paramsModel.criticalValue }}</span>
          </div>
          <div class="it">
            <span class="tlt">形态：</span>
            <span class="value">
                    <el-radio-group v-model="paramsModel.state" size="mini">
                        <el-radio mini v-for="(item,i) in stateOptions" :key="i"
                                  :label="item.label">{{ item.name }}</el-radio>
                    </el-radio-group>
                              </span>
          </div>
          <div class="it">
            <span class="tlt">物质分类：</span>
            <span class="value" style="width: 260px;">
                   <el-checkbox-group v-model="paramsModel.substanceType" size="mini" >
                      <el-checkbox mini v-for="(item, i) in filteredSubstanceTypeOptions" :key="i" :label="item.label">
                        {{ item.name }}
                      </el-checkbox>
                    </el-checkbox-group>
                  </span>
            <p
              v-if="filteredSubstanceTypeOptions && filteredSubstanceTypeOptions.length === 2"    style="font-size:12px; color:#DC143C; margin-top:5px;"
            >*如同时涉水、涉气，请同时勾选</p>
          </div>
          <div class="it">
            <span class="tlt">数量(吨)：</span>
            <span class="value">
                                  <!-- <el-input-number v-model="paramsModel.count" :min="0" :step="0.01" size="small"></el-input-number> -->
                    <el-input v-model="paramsModel.count" type="number" @input.native="changeMaxCode" :min="0" :step="0.01"
                              placeholder="请填写最大储存量"></el-input>
                    <span style="padding-left:10px;">(填写最大储存量)</span>
                              </span>
          </div>
          <div class="it">
            <span class="tlt">折纯量(吨)：</span>
            <span class="value">
                    <el-input v-model="paramsModel.purity" type="number" @input.native="changePurity" :min="0"
                              :step="0.01"></el-input>
                              </span>
          </div>
          <div class="it">
            <span class="tlt">备注：</span>
            <span class="value">
                    <el-input v-model="paramsModel.remark" type="text" :maxlength="20"></el-input>
                              </span>
          </div>
        </div>
      </div>
      <!--      <p style="margin-top:10px">找不到物质？<span style="color: #20a0ff;cursor: pointer" @click="addBox">我要新增</span></p>-->
      <span slot="footer" class="dialog-footer">
                  <el-button @click="dialogVisible = false">取 消</el-button>
                  <el-button type="primary" @click="submitMt">确 定</el-button>
            </span>
    </el-dialog>
    <!-- 修改风险物资 -->
    <el-dialog title="修改风险物质" v-model="modifyVisible" size="small" id="modifyVisible">
      <div style="overflow: hidden;">
        <div class="risk-right riskmd" style="height: auto; min-height: 400px;">
          <div class="it">
            <span class="tlt">物质：</span>
            <span class="value">{{ singleRisk.name }}</span>
          </div>
          <div class="it">
            <span class="tlt">CAS号：</span>
            <span class="value">{{ singleRisk.cas }}</span>
          </div>
          <div class="it">
            <span class="tlt">临界量：</span>
            <span class="value">{{ singleRisk.criticalValue }}</span>
          </div>
          <div class="it">
            <span class="tlt">形态：</span>
            <span class="value">
                    <el-radio-group v-model="singleRisk.state" size="mini">
                        <el-radio mini v-for="(item,i) in stateOptions" :key="i"
                                  :label="item.label">{{ item.name }}</el-radio>
                    </el-radio-group>
                              </span>
          </div>
          <template v-if="singleRisk.substanceTypeListStr">
            <div class="it">
              <span class="tlt">物质分类：</span>
              <span class="value">
    <el-checkbox-group v-model="singleRisk.substanceType" size="mini">
      <el-checkbox mini v-for="(item, i) in filteredSubstanceTypeOptions" :key="i" :label="item.label">
        {{ item.name }}
      </el-checkbox>
    </el-checkbox-group>
  </span>
            </div>
          </template>
          <div class="it">
            <span class="tlt">数量：</span>
            <span class="value">
                    <el-input v-model="singleRisk.count" type="number" @input.native="changeMaxCode" :min="0" :step="0.01"
                              placeholder="请填写最大储存量"></el-input>
                    <span style="padding-left:10px;">(填写最大储存量)</span>
                  </span>
          </div>
          <template v-if="singleRisk.substanceTypeListStr">
            <div class="it">
              <span class="tlt">折纯量(吨)：</span>
              <span class="value">
                      <el-input v-model="singleRisk.purity" type="number" @input.native="changePurity" :min="0"
                                :step="0.01"></el-input>
                    </span>
            </div>
            <div class="it">
              <span class="tlt">备注：</span>
              <span class="value">
                      <el-input v-model="singleRisk.remark" type="text" :maxlength="20"></el-input>
                    </span>
            </div>
          </template>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
                  <el-button @click="modifyVisible = false">取 消</el-button>
                  <el-button type="primary" @click="submitSaveMT">确 定</el-button>
                </span>
    </el-dialog>
    <!-- 添加风险物质 -->
    <el-dialog title="新增物质" :visible.sync="addnew" size="tiny">
      <el-form ref="formlist" :model="formlist" label-width="100px">
        <el-form-item label="物质">
          <el-input v-model="formlist.name"></el-input>
        </el-form-item>
        <el-form-item label="CAS号">
          <el-input v-model="formlist.cas"></el-input>
        </el-form-item>
        <el-form-item label="临界值(吨)">
          <el-input v-model="formlist.criticalValue" type="number"></el-input>
        </el-form-item>
        <el-form-item label="重点环境管理危险化学品">
          <el-radio-group v-model="formlist.serious">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="风险属性">
          <el-select v-model="formlist.riskType" placeholder="请选择风险属性" style="width:100%;" @change="changeType">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="formlist.remark"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button @click="addnew = false">取 消</el-button>
          <el-button type="primary" @click="addnewsupply">确 定</el-button>
        </span>
    </el-dialog>
  </div>
</template>
<script>
import Burst from './../../data/emer/burst'
import supply from '../../data/emer/supply.js'

export default {
  data() {
    return {
      radio2: '',
      form: {
        name: ''
      },
      input: '',
      addnew: false,
      tableData: [],
      modifyVisible: false,
      dialogVisible: false,
      searchrisk: '',
      materialData: [],
      matSelIndex: -1,
      state: '',
      singleRisk: {},
      groupedData: [], // 用于存储分组后的数据
      isGrouped: false, // 标记是否进行分类展示
      stateOptions: [{
        label: 1,
        name: '固态'
      }, {
        label: 2,
        name: '液态'
      }, {
        label: 3,
        name: '气态'
      }],
      substanceTypeOptions: [{
        label: 1,
        name: '涉水风险物质'
      }, {
        label: 2,
        name: '涉气风险物质'
      }],
      filteredSubstanceTypeOptions: [],
      numbers: null,
      textareas: '',
      paramsModel: {
        count: 1,
        purity: null,
        remark: '',
        materialId: '',
        name: '',
        state: '',
        substanceType: '',
        solution: '',
        cas: '',
        criticalValue: ''
      },
      // 新增风险
      formlist: {
        cas: '',
        criticalValue: '',
        id: '',
        name: '',
        remark: '',
        riskType: '',
        serious: '',
        verifiedStatus: ''
      },
      options: [{
        value: '1',
        label: '有毒气态物质'
      }, {
        value: '2',
        label: '易燃易爆气态物质'
      }, {
        value: '3',
        label: '有毒液体物质'
      }, {
        value: '4',
        label: '易燃液态物质'
      }, {
        value: '5',
        label: '其他有毒物质'
      }, {
        value: '6',
        label: '遇水生成有毒气体的物质'
      }, {
        value: '7',
        label: '重金属及其化合物'
      }, {
        value: '8',
        label: '其他类物质及污染物'
      },],
      activeNames: [], // 用于控制折叠面板的展开状态
      qValueSummary: [], // 用于存储每种物质类型的Q值合计
      spanArr: [], // 用于存储合并单元格的信息
      hasSubstanceType: false, // 标记是否有物质类型数据
    }
  },
  mounted() {
    this.$nextTick(() => {
      let $dialog = document.getElementById('dialogVisible')
      let $modifyVisible = document.getElementById('modifyVisible')
      if (!$dialog) return
      let $elDialog = $dialog.getElementsByClassName('el-dialog')[0]
      let $elDialog1 = $modifyVisible.getElementsByClassName('el-dialog')[0]
      $elDialog.style.width = '822px'
      $elDialog1.style.width = '620px'
    })
  },
  created() {
    //this.get_material_list()
    this.get_risk_list()
  },
  methods: {
    // 选择类型
    changeType(val) {
      this.formlist.riskType = val
    },
    addnewsupply() {
      if (this.formlist.name == '') {
        this.$message.error('物质名称不为空')
        return
      } else {
        this.add_risk()
      }
    },
    // 新增新的物质
    addBox() {
      this.addnew = true
    },
    // 添加
    add() {
      this.dialogVisible = true
      this.get_material_list()
    },
    handleSel(item, index) {
      this.matSelIndex = index
      this.paramsModel = {
        count: 1,
        materialId: item.id,
        name: item.name,
        state: '',
        solution: '',
        cas: item.cas,
        planId: sessionStorage.planIdval,
        criticalValue: item.criticalValue,
        substanceType: []
      }
      // 解析 substanceType 字符串为数组
      const substanceTypeArray = item.substanceType ? item.substanceType.split(',').map(Number) : [];

      // 过滤 substanceTypeOptions
      this.filteredSubstanceTypeOptions = this.substanceTypeOptions.filter(option => substanceTypeArray.includes(option.label));
    },
    // 删除
    delectRisk(item) {
      (async () => {
        try {
          let info = await Burst.material_delect({
            id: item.id
          })
          if (info.status) {
            this.get_risk_list()
            this.$message.success('删除风险物质成功')
          }
        } catch (err) {
          console.log(err)
        }
      })()
    },

    // 验证
    verifyResult() {
      return this.tableData.length >= 1 ? true : false
    },

    // 修改
    modify(item) {
      this.singleRisk = {...item};
      this.singleRisk.substanceType = item.substanceType ? item.substanceType.split(',').map(Number) : [];
      // 解析 substanceTypeListStr 为数组
      const substanceTypeArray = this.singleRisk.substanceTypeListStr ?
        this.singleRisk.substanceTypeListStr.split(',').map(Number) : [];
      // 过滤 substanceTypeOptions
      this.filteredSubstanceTypeOptions = this.substanceTypeOptions.filter(option =>
        substanceTypeArray.includes(item.label)
      );
      this.modifyVisible = true;
    },
    submitSaveMT() {
      (async () => {
        try {
          const paramsToSave = { ...this.singleRisk, substanceType: this.singleRisk.substanceType.join(',') };
          let info = await Burst.material_modify(paramsToSave)
          if (info.status) {
            this.$message.success('修改风险物质成功')
            this.modifyVisible = false
            // 修改成功后立即刷新数据
            this.get_risk_list()
          }
        } catch (err) {
          this.$message.error('网络异常，请稍后重试')
        }
      })()
    },

    // 保存
    submitMt() {
      if (!this.paramsModel.name) {
        this.$message.error('请选择应急物资')
        return
      }
      if (!this.paramsModel.state) {
        this.$message.error('请选择形态')
        return
      }
      if (!this.paramsModel.substanceType) {
        this.$message.error('请选择物质分类')
        return
      }
       // 将 substanceType 数组转换为逗号分隔的字符串
     const paramsToSave = { ...this.paramsModel, substanceTypeList: this.paramsModel.substanceType };
      paramsToSave.substanceType = null;
      this.save_material(paramsToSave)
      this.dialogVisible = false
      this.paramsModel = {
        count: 1,
        materialId: '',
        name: '',
        state: '',
        solution: '',
        casCode: '',
        criticalValue: ''
      }
      this.matSelIndex = -1
      this.filteredSubstanceTypeOptions = [];
      this.paramsModel.substanceType = [];
    },
    // 保存
    save_material(params) {
      (async () => {
        try {
          let info = await Burst.material_save(params)
          this.get_risk_list()
          this.searchrisk = ''
          this.get_material_list()
        } catch (err) {
          console.log(err)
        }
      })()
    },
    // 获取列表
    get_risk_list() {
      (async () => {
        try {
          let info = await Burst.material_lists({
            planId: sessionStorage.planIdval
          });
          if (info.status) {
            this.tableData = info.data ? info.data : [];
            this.checkAndProcessTableData();
          }
        } catch (err) {
          console.log(err);
        }
      })();
    },
    // 检查并处理表格数据
    checkAndProcessTableData() {
      // 检查是否有物质类型数据
      this.hasSubstanceType = this.tableData.some(item => item.substanceType);

      if (this.hasSubstanceType) {
        this.processTableData();
      }
    },
    // 处理表格数据，计算Q值合计和分组信息
    processTableData() {
      // 按物质类型分组
      const groups = {};
      this.tableData.forEach(item => {
        if (!groups[item.substanceType]) {
          groups[item.substanceType] = {
            type: item.substanceType,
            items: [],
            total: 0
          };
        }
        groups[item.substanceType].items.push(item);
        groups[item.substanceType].total += Number(item.qValue || 0);
      });

      // 转换为数组并排序
      this.groupedData = Object.values(groups).sort((a, b) => a.type - b.type);
    },
    formatSubstanceType(substanceType) {
      const substanceTypeOption = this.substanceTypeOptions.find(option => option.label === substanceType);
      return substanceTypeOption ? substanceTypeOption.name : '';
    },
    // 获取风险物资列表
    get_material_list() {
      (async () => {
        try {
          let info = await Burst.material_search({
            keyword: this.searchrisk,
            size: 1000000
          })
          if (info.status) {
            this.materialData = info.data.content
          }
        } catch (err) {
          console.log(err)
        }
      })()
    },
    // 搜索
    handleIconClick() {
      this.get_material_list()
    },
    formatState(state) {
      let res = ''
      switch (state) {
        case 1:
          res = '固态'
          break
        case 3:
          res = '气态'
          break
        case 2:
          res = '液态'
          break
      }
      return res
    },
    // 新增风险物质
    add_risk() {
      (async () => {
        let createState = await supply.material_create(this.formlist)
        if (createState.status) {
          this.$message.success('风险物质新增成功');
          setTimeout(() => {
            this.addnew = false
            this.get_material_list()
          }, 500)
        } else {
          this.$message.error(createState.msg);
        }
      })()
    },

    //输入框保留4位小数
    changeMaxCode() {
      var that = this;
      this.$nextTick(() => {
        let count = that.paramsModel.count.split('.');
        if (count.length >= 2) {
          if (count[1].length > 4) {
            let newcount = count[0] + '.' + count[1].substr(0, 4)
            that.paramsModel.count = Number(newcount);
          }
        }
      })
    },

    //输入框保留4位小数
    changePurity() {
      var that = this;
      this.$nextTick(() => {
        let purity = that.paramsModel.purity.split('.');
        if (purity.length >= 2) {
          if (purity[1].length > 4) {
            let newcount = purity[0] + '.' + purity[1].substr(0, 4)
            that.paramsModel.purity = Number(newcount);
          }
        }
      })
    },
    objectSpanMethod({row, column, rowIndex, columnIndex}) {
      if (columnIndex === 1) { // 物质类型列
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col
        }
      }
    },
    formatRiskType(riskType) {
      const riskTypeMap = {
        '1': '第一部分 有毒气态物质',
        '2': '第二部分 易燃易爆气态物质',
        '3': '第三部分 有毒液态物质',
        '4': '第四部分 易燃液态物质',
        '5': '第五部分 其他有毒物质',
        '6': '第六部分 遇水生成有毒气体的物质',
        '7': '第七部分 重金属及其化合物',
        '8': '第八部分 其他类物质及污染物'
      };
      return riskTypeMap[riskType] || riskType;
    },
  }
}

</script>
<style scoped>
.risk-left {
  width: 200px;
  height: 360px;
  border: 1px solid #ccc;
  overflow: hidden;
  float: left;
}

.risk-right {
  float: left;
  border: 1px solid #ccc;
  border-left: 0;
  width: 578px;
  height: 362px;
  box-sizing: border-box;
}

.top {
  width: 100%;
  box-sizing: border-box;
  padding: 10px;
  position: relative;
}

.list {
  width: 100%;
  height: 310px;
  overflow-y: auto;
  border-top: 1px solid #ccc;
}

.list li {
  height: 30px;
  line-height: 30px;
  padding: 0 10px;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  transition: all 0.5s ease-in;
}

.list li:nth-child(2n) {
  background: #f9f9f9
}

.list li:hover,
.list li.activeSel {
  color: #00c0ef;
  background-color: #ecf5ff;
}

.it {
  padding-left: 20px;
  line-height: 40px;
  height: 40px;
  overflow: hidden;
  border-bottom: 1px dashed #ccc;
}

.value {
  display: inline-block;
  width: 336px;
  height: 40px;
  float: left;
}

.wv {
  width: 150px;
}

.it .tlt {
  width: 85px;
  display: inline-block;
  float: left;
  text-align: right;
  margin-right: 20px;
}

.mgtlt {
  margin-left: 50px;
}

.riskName i {
  display: none;
  margin-left: 10px;
}

.riskName:hover i {
  color: #20a0ff;
  display: inline-block;
}

.riskmd {
  border: 1px solid #ccc;
}

.valuename {
  width: 215px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}

.q-value-summary {
  margin-top: 20px;
  padding: 0px;
  background-color: #f5f7fa;
  border-radius: 4px;
}

.q-value-summary h4 {
  margin-bottom: 0px;
  color: #606266;
}

.q-value-summary div {
  margin-bottom: 5px;
  color: #606266;
}

.group-card {
  margin-bottom: 8px;
}

.group-card >>> .el-card__body {
  padding: 5px !important;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.q-value {
  color: #409EFF;
  font-weight: bold;
}

.grouped-table-container {
  margin-top: 0px;
}

.group-card >>> .el-card__header {
  padding: 8px 20px;
  border-bottom: 1px solid #d1dbe5;
  box-sizing: border-box;
}

.card-header span:first-child {
  font-weight: bold;
}


</style>



// WEBPACK FOOTER //
// RiskMaterial.vue?34803532